import React from 'react'
import { Document, Page, View, Text, Image, StyleSheet } from '@react-pdf/renderer'
import { post_catalog } from '../../../../escalas/estres_post_traumatico/post_traumatico/p_t_catalog'
import { IMAGE_API, myHospitals } from '../../../../resources'

const frecuencias = ["Nunca", "A Veces", "2-3 Veces", "4-6 Veces", "A diario"]
const gravedades = ["Nada", "Leve", "Moderada", "Marcada", "Extrema"]

function getDavidsonInterpretation(score) {
    if (score <= 19) return 'Síntomas mínimos'
    if (score <= 39) return 'Síntomas leves'
    if (score <= 79) return 'Síntomas moderados'
    return 'Síntomas graves'
}

const styles = StyleSheet.create({
    page: {
        padding: 32,
        fontSize: 10,
        fontFamily: 'Helvetica',
    },
    header: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: 16,
    },
    logo: {
        width: 80,
        height: 50,
        objectFit: 'contain',
    },
    headerRight: {
        textAlign: 'right',
        alignItems: 'flex-end',
    },
    title: {
        fontSize: 14,
        fontWeight: 700,
        color: '#505050',
    },
    subtitle: {
        fontSize: 10,
        marginTop: 2,
        color: '#505050',
    },
    infoRow: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        marginBottom: 12,
    },
    scoreBox: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        backgroundColor: '#e6f4ff',
        padding: 8,
        borderRadius: 6,
        marginBottom: 10,
    },
    scoreText: {
        fontWeight: 700,
    },
    row: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        padding: 6,
        borderRadius: 4,
    },
    rowEven: {
        backgroundColor: '#f5f5f5',
    },
    question: {
        flex: 1,
    },
    detail: {
        width: '18%',
        textAlign: 'right',
    },
})

export default function PostTraumaticoPDF({ pacienteData, fecha, post_traumatico = {} }) {
    const score = post_catalog.reduce((total, _, i) => {
        const pair = post_traumatico[String(i + 1)]
        return pair ? total + (pair[0] || 0) + (pair[1] || 0) : total
    }, 0)

    return (
        <Document>
            <Page size="LETTER" style={styles.page}>
                <View style={styles.header}>
                    <Image src={IMAGE_API + myHospitals[0]?.logo} style={styles.logo} />
                    <View style={styles.headerRight}>
                        <Text style={styles.title}>Escala de Trauma de Davidson</Text>
                        {fecha && <Text style={styles.subtitle}>{new Date(fecha).toLocaleDateString('es-MX')}</Text>}
                    </View>
                </View>

                <View style={styles.infoRow}>
                    <Text>Paciente: {pacienteData?.name || '-'}</Text>
                </View>

                <View style={styles.scoreBox}>
                    <Text style={styles.scoreText}>Puntuación total: {score} / 136</Text>
                    <Text style={styles.scoreText}>{getDavidsonInterpretation(score)}</Text>
                </View>

                {
                    post_catalog.map((pr, i) => {
                        const pair = post_traumatico[String(i + 1)]
                        return (
                            <View key={i} style={i % 2 === 0 ? [styles.row, styles.rowEven] : styles.row}>
                                <Text style={styles.question}>{pr}</Text>
                                <Text style={styles.detail}>F: {pair ? frecuencias[pair[0]] : '-'}</Text>
                                <Text style={styles.detail}>G: {pair ? gravedades[pair[1]] : '-'}</Text>
                            </View>
                        )
                    })
                }
            </Page>
        </Document>
    )
}
